<template>
  <main class="main" role="main">
    <div class="page">
      <div class="inner">
        <div class="lnb">
          <ul>
            <li><p class="home"></p></li>
            <li><p>소식 알림</p></li>
            <li><p>외식 산업 뉴스</p></li>
          </ul>
        </div>
        <div class="page_ttl">
          <h1 class="h1">
            <span>외식 산업 뉴스</span>
          </h1>
        </div>
        <div class="page_con">
          <div class="gallery">
            <ul class="gallery_ul">
              <li
                class="gallery_li"
                v-for="(item, index) in items"
                :key="index"
                @click="fnUrl(item)"
              >
                <div class="thumb">
                  <div class="inner">
                    <img
                      :src="$ConstCode.getImagePath(item.imagePath)"
                      alt=""
                      v-if="!$Util.isEmpty(item.imagePath)"
                    />
                  </div>
                </div>
                <div class="txt_box">
                  <p class="txt">
                    {{ item.title }}
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'news-kfood-index',
  description: '외식뉴스',
  data: function() {
    return {
      params: {
        page: 1,
        limit: -1,
        searchText: ''
      },
      items: [],
      pageInfo: {}
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData: async function(page = 1) {
      this.params.page = page
      const res = await this.$NewsSvc.fetchKfoodNewsList(this.params)
      if (res.code === 1) {
        this.items = res.entity.list
        this.pageInfo = res.entity.pageInfo
      }
    },
    fnUrl: function(item) {
      if (this.$Util.isEmpty(item.url)) return
      window.open(item.url, '_blank')
    }
  }
}
</script>

<style scoped></style>
